var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips"},[_c('img',{attrs:{"src":require("@/assets/images/order/tip-down.png")}}),_c('div',{staticClass:"aflex v"},[_c('div',[_vm._v("月嫂已发起上户请求")]),_c('div',[_vm._v("上户时间："+_vm._s(_vm.applyDate))])])])}
var staticRenderFns = []

export { render, staticRenderFns }